import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col, Paragraph} from '@modifi/ui'

import {CardWrapper, StyledImgCol} from './styles'
import {StyledH4} from '../common'

const propTypes = {
  cardDetails: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string,
  }),
}
const defaultProps = {
  cardDetails: {
    headline: '',
    description: '',
    icon: '',
  },
}

export type USPCardProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const USPCard: React.FC<USPCardProps> = ({cardDetails}) => (
  <CardWrapper>
    <Row>
      <StyledImgCol>
        {cardDetails?.icon && (
          <img src={cardDetails?.icon} alt={`card-icon-${cardDetails?.headline}`} />
        )}
      </StyledImgCol>
    </Row>
    <Row justifyContent="center" mt={20} mb={6}>
      <Col>
        <StyledH4>{cardDetails?.headline}</StyledH4>
      </Col>
    </Row>
    <Row>
      <Col>
        <Paragraph>{cardDetails?.description}</Paragraph>
      </Col>
    </Row>
  </CardWrapper>
)

USPCard.propTypes = propTypes

USPCard.defaultProps = defaultProps

export default USPCard
